// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"az_sUb","Row":"az_tUb","Item":"az_uUb","Arrows":"az_vUb","Arrow":"az_wUb","DesktopVisible":"az_xUb","Previous":"az_yUb","Next":"az_zUb","FlippedIcon":"az_AUb"};